import {AnyAction} from 'redux';
import Types from '../../../actions/Types';

import {mergeResponse, QueryState} from '../Response';

import ContactCategory from '../../../../domain/entities/writer/ContactCategory';
import PaginatedResult from '../../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexWriterContactCategoriesSuccess: {
      const result = action.payload as PaginatedResult<ContactCategory>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
